<template>
    <div id="overlapped-header" class="text-light">
      <header-o />
      <div class="padding-top-5"></div>
      <div class="gradient-border" style="background-color: #f1dddd; margin: 10px; padding: 15px; border-radius: 5px;">
        <p style="margin: 0; font-size: 14px; font-weight: 600; color: black;">How would you define your ‘risk appetite’?</p>
        <!-- Text Based Options -->
       <div v-if="isText">
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer;">I’m afraid to lose money</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; cursor: pointer;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px;">I’m willing to take calculated risks</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; cursor: pointer;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px;">You lose some, you make some</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; cursor: pointer;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px;">I’m not sure</p>
        </div>
       </div>
       <!-- Image Based Option -->
      <div v-else style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: space-between;">
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; width: 40%;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer;">Image 1</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; width: 40%; height: 80px;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer; " >Image 2</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; width: 40%; height: 80px;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer; " >Image 3</p>
        </div>
        <div style="background-color: #ffffff; padding: 10px; margin-top: 10px; border-radius: 5px; width: 40%; height: 80px;">
            <p style="color: black; margin: 0; font-weight: 400; font-size: 12px; cursor: pointer; " >Image 4</p>
        </div>
      </div>
        <div style="margin-top: 15px; display: flex; justify-content: center; align-items: center;">
            <button style="padding: 5px 10px; width: 30%; border: none; background-color: #c7222a; border-radius: 5px; color: #ffffff; cursor: pointer;">></button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import CustomHeader from "@/components/header.vue";
  
  export default {
    components: {
      "header-o": CustomHeader
    },
    data() {
      return {
        headerData: {
          onlyHeader: false,
          rewards: false,
        },
        isText: true
      };
    },
    created() {
      const store = this.$store.state;
      store.showHeader = true;
      store.showWallet = false;
      store.showHistory = false;
      store.headTitle = "Poll";
      store.user.headerBalance.show = false;
    }
  };
  </script>

  <style>
 .gradient-border {
  border-top: 1px solid transparent;
  border-image: linear-gradient(to right, rgba(199,34,42,0.1), #7C2279, rgba(199,34,42,0.1)) 1;
  border-image-slice: 1;
}


</style>
  